import React from "react";
import { useParams } from "react-router-dom";
import { getGameConfig } from "../games";
import { useGameplaySession } from "../hooks/useGameplaySession";
import { GameStatus } from "../types/gameplay";
import ClozeGame from "./ClozeGame";

const Cloze = ({
  dateOverride = null,
  sessionOptions = null,
}) => {
  const { date: routeDate } = useParams();
  const date = dateOverride || routeDate;
  const gameConfig = getGameConfig("cloze");

  const {
    puzzleConfig,
    state: sessionState,
    solutions, // Only available when game is complete (won/lost)
    status,
    gameOver,
    won,
    justWon, // True only when user wins during this session
    justLost, // True only when user loses during this session
    isLoading,
    error: sessionError,
    isEventPending,
    dispatchEvent,
  } = useGameplaySession(gameConfig.id, date, {
    deriveStatusFromLocalStorage: (data) => {
      if (data?.completed) return GameStatus.WON;
      if (data?.gameOver) return GameStatus.LOST;
      if (data?.lives < 5 || data?.feedback) return GameStatus.IN_PROGRESS;
      return GameStatus.NOT_STARTED;
    },
    ...(sessionOptions || {}),
  });

  return (
    <ClozeGame
      key={sessionState?.session_id || date}
      date={date}
      gameConfig={gameConfig}
      puzzleConfig={puzzleConfig}
      sessionState={sessionState}
      solutions={solutions}
      status={status}
      gameOver={gameOver}
      won={won}
      justWon={justWon}
      justLost={justLost}
      isLoading={isLoading}
      sessionError={sessionError}
      isEventPending={isEventPending}
      dispatchEvent={dispatchEvent}
    />
  );
};

export default Cloze;
